import * as t from "io-ts";

export const LocationMetaWorkCodec = t.intersection([
  t.type({
    workId: t.string,
    workType: t.string,
    workEntityType: t.string,
    status: t.string,
  }),
  t.partial({
    ticketId: t.string,
    pickupId: t.string,
    pickupInDttm: t.number,
    pickupDttm: t.number,
    pickupOutDttm: t.number,
    pickupSiteId: t.string,
    pickupSiteName: t.string,
    pickupSiteCompanyId: t.string,
    pickupSiteCompanyName: t.string,
    pickupFreightTypeId: t.string,
    pickupFreightTypeName: t.string,
    pickupServiceTypeId: t.string,
    pickupServiceTypeName: t.string,
    pickupQuantity: t.number,
    pickupQuantityUom: t.string,
    deliveryId: t.string,
    deliveryInDttm: t.number,
    deliveryDttm: t.number,
    deliveryOutDttm: t.number,
    deliverySiteId: t.string,
    deliverySiteName: t.string,
    deliverySiteCompanyId: t.string,
    deliverySiteCompanyName: t.string,
    deliveryFreightTypeId: t.string,
    deliveryFreightTypeName: t.string,
    deliveryServiceTypeId: t.string,
    deliveryServiceTypeName: t.string,
    deliveryQuantity: t.number,
    deliveryQuantityUom: t.string,
  }),
]);

export const LocationMetaWorkArrayCodec = t.array(
  LocationMetaWorkCodec
);

export type LocationMetaWork = t.TypeOf<typeof LocationMetaWorkCodec>;
